import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useAppContext } from './context/AppContext';
import Login from './Login'
import Dashboard from './Dashboard'
import {Navigate,Routes,Route, useNavigate} from 'react-router-dom'
import Register from './Register';
import Verify from './Verifyemail';
import PasswordReset from './PasswordReset';
import ResetPassword from './Resetpass';
import Products from  './pages/products/Products'
import Main from './components/Main';
import Permits from './pages/permits/Permits';
import Mapper from './pages/Mapper';
import Files from './pages/Files';
import Campaigns from './pages/Campaigns';
import Newjob from './pages/Newjob';
import Invoice from './pages/invoices/Invoice';
import Viewinvoice from './pages/invoices/Viewinvoice';
import CustJobPanel from './pages/jobs/CustJobPanel'
import Jobs from './pages/jobs/Jobs';
import NewJob from './pages/jobs/NewJob';
import { JobProvider } from './context/JobContext';
import Addons from './pages/jobs/Addons';
import Previewjob from './pages/jobs/Previewjob';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminMain from './pages/Admin/AdminMain';
import JobPage from './pages/Admin/Pages/JobPage';
import Promotions from './pages/Promotions/Promotions';
import Informed from './pages/Promotions/Informed';
import Intergrated from './pages/Promotions/Integrated';
import Reply from './pages/Promotions/Reply';
import Sustained from './pages/Promotions/Sustained';
import PDFGenerator from './pages/jobs/PDF';
import Schedule from './pages/Promotions/Schedule';
import { PromoProvider } from './context/PromoContext';
import InformedDelv  from './pages/informed/InformedDelv';
import NewCampaign from './pages/informed/NewCampaign';
import Test from './Test';
import Job from './pages/jobs/Job';
import Veiwpdf from './pages/jobs/Veiwpdf';
import CsvViewer from './pages/jobs/CsvVeiwer';
import Customers from  './pages/customers/Customers'
import Newcustomer from './pages/customers/Newcustomer';
import Customer from './pages/customers/Customer';


// // Create Axios instance with timeout
// const api = axios.create({
//   //baseURL: 'http://localhost:5003/api',
//   baseURL: 'https://lightningpresort-3c0bfe3acad3.herokuapp.com/api',
//   withCredentials: true, // Ensures cookies are sent with requests
//   timeout: 5000,
// });

const ProtectedRoute = ({ children }) => {
  const { authState } = useAppContext();
  if (authState.loading) {
    return <div>Loading...</div>;
  }
  return authState.isAuthenticated ? children : <Navigate to="/" />;
};

// Main App component
const App = () => {
    const { user,logout } = useAppContext();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
 
  const [serverError, setServerError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState(null); // Store token for expiration display
const nav = useNavigate()
console.log(user)
  return (
    <Routes>
    <Route path="/" element={<Login />} />
     <Route path="/verify" element={<Verify />} />
     <Route path="/forgot" element={<PasswordReset />} />
     <Route path="/register" element={<Register />} />
     <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/test" element={<Test />} />

    <Route path="/dashboard"element={ <ProtectedRoute><JobProvider><AdminDashboard /></JobProvider></ProtectedRoute>} >
<Route path="customers" element={ <ProtectedRoute><Customers /></ProtectedRoute>} /> 
<Route path="customer/:id" element={ <ProtectedRoute><Customer /></ProtectedRoute>} /> 
<Route path="newcustomer" element={ <ProtectedRoute><Newcustomer /></ProtectedRoute>} /> 

<Route path="newjob/:id" element={ <ProtectedRoute><NewJob /></ProtectedRoute>} />

<Route path="products" element={ <ProtectedRoute><Products /></ProtectedRoute>} />

<Route path="permits" element={ <ProtectedRoute><Permits /></ProtectedRoute>} />

{/* 
<Route path="promotions" element={ <ProtectedRoute><PromoProvider><Promotions /></PromoProvider></ProtectedRoute>} />
<Route path="schedule" element={ <ProtectedRoute><Schedule /></ProtectedRoute>} /> */}

{/* <Route path="newcampaign" element={ <ProtectedRoute><NewCampaign /></ProtectedRoute>} />
<Route path="informdelv" element={ <ProtectedRoute><InformedDelv /></ProtectedRoute>} />

<Route path="mapper" element={ <ProtectedRoute><Mapper /></ProtectedRoute>} />
<Route path="addons" element={ <ProtectedRoute><Addons /></ProtectedRoute>} />
<Route path="previewjob" element={ <ProtectedRoute><Previewjob /></ProtectedRoute>} />
<Route path="invoices" element={ <ProtectedRoute><Invoice /></ProtectedRoute>} />

<Route path="jobs" element={ <ProtectedRoute><Jobs /></ProtectedRoute>} />
<Route path="job/:id" element={ <ProtectedRoute><Job /></ProtectedRoute>} />
<Route path="campaigns" element={ <ProtectedRoute><Campaigns /></ProtectedRoute>} />
<Route path="view" element={ <ProtectedRoute><Viewinvoice /></ProtectedRoute>} />
<Route path="newjob" element={ <ProtectedRoute><Newjob /></ProtectedRoute>} />

<Route path="job/veiwpdf/:id" element={ <ProtectedRoute><Veiwpdf /></ProtectedRoute>} />
<Route path="job/csv/:id" element={ <ProtectedRoute><CsvViewer /></ProtectedRoute>} />
<Route path="pdf" element={ <ProtectedRoute><PDFGenerator /></ProtectedRoute>} />

<Route path="" element={ <ProtectedRoute>{user?.role === '9' ?<AdminMain /> : <Main />}</ProtectedRoute>} />
<Route path="jobpanel/:id" element={ <ProtectedRoute>{user?.role === '9' ?<JobPage /> : <Main />}</ProtectedRoute>} />
<Route path="cust/jobs/:id" element={ <ProtectedRoute><CustJobPanel /> </ProtectedRoute>} /> */}
       </Route>
    
  </Routes>
  );
};

// Dashboard component

// Login component
// const Login = ({ setShowRegister, setIsLoggedIn, setUser, setServerError, setToken }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');

//   const handleLogin = async () => {
//     console.log('handleLogin: Attempting login', { username });
//     try {
//       const response = await api.post('/login', { username, password });
//       console.log('handleLogin: Login successful', response.data);
//       setIsLoggedIn(true);
//       setUser(response.data.user);
//       setToken(response.data.token); // Store token for expiration display
//       setError('');
//       setServerError(false);
//     } catch (error) {
//       console.error('handleLogin: Login failed', {
//         message: error.response?.data?.message || error.message,
//         status: error.response?.status,
//       });
//       if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
//         setServerError(true);
//       } else {
//         setError(error.response?.data?.message || 'Login failed');
//       }
//     }
//   };

//   return (

//   );
// };

// Register component
// const Register = ({ setShowRegister, setIsLoggedIn, setUser, setServerError, setToken }) => {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');

//   const handleRegister = async () => {
//     console.log('handleRegister: Attempting registration', { username });
//     try {
//       const response = await api.post('/register', { username, password });
//       console.log('handleRegister: Registration successful', response.data);
//       setIsLoggedIn(true);
//       setUser(response.data.user);
//       setToken(response.data.token); // Store token for expiration display
//       setError('');
//       setShowRegister(false);
//       setServerError(false);
//     } catch (error) {
//       console.error('handleRegister: Registration failed', {
//         message: error.response?.data?.message || error.message,
//         status: error.response?.status,
//       });
//       if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
//         setServerError(true);
//       } else {
//         setError(error.response?.data?.message || 'Registration failed');
//       }
//     }
//   };

//   return (
//     <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-md mt-8">
//       <h2 className="text-2xl font-bold mb-4">Register</h2>
//       {error && <p className="text-red-500 mb-4">{error}</p>}
//       <div className="mb-4">
//         <label className="block text-gray-700">Username</label>
//         <input
//           type="text"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//           className="w-full px-3 py-2 border rounded"
//         />
//       </div>
//       <div className="mb-4">
//         <label className="block text-gray-700">Password</label>
//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           className="w-full px-3 py-2 border rounded"
//         />
//       </div>
//       <button
//         onClick={handleRegister}
//         className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 mb-4"
//       >
//         Register
//       </button>
//       <p>
//         Already have an account?{' '}
//         <button
//           onClick={() => setShowRegister(false)}
//           className="text-blue-500 hover:underline"
//         >
//           Login
//         </button>
//       </p>
//     </div>
//   );
// };

export default App;